program wsWEB;

uses
  Vcl.Forms,
  WEBLib.Forms,
  umain in 'umain.pas'{*.html},
  uWebClientViewer in 'uWebClientViewer.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.CreateForm(TFormClientList, FormClientList);
  Application.Run;
end.
